import { 
  useRemoveUserFromCourseMutation,
  useAddUserToGroupMutation,
  useRemoveUserFromGroupMutation,
  useAddUserToCourseMutation,
  useRemoveUserFromStoreMutation
} from '../usersApi';
import { enqueueSnackbar } from 'notistack';
import i18next from 'i18next';

export const useUsersActions = () => {
  const [removeUserFromCourseTrigger] = useRemoveUserFromCourseMutation();
  const [addUserToGroupTrigger] = useAddUserToGroupMutation();
  const [removeUserFromGroupTrigger] = useRemoveUserFromGroupMutation();
  const [addUserToCourseTrigger] = useAddUserToCourseMutation();
  const [removeUserFromStoreTrigger] = useRemoveUserFromStoreMutation();

  const removeUserFromCourse = async ({ userId, courseId }) => {
    try {
      const result = await removeUserFromCourseTrigger({ userId, courseId }).unwrap();
      enqueueSnackbar(i18next.t('users.removeFromCourse'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.removeFromCourseFailed'), { variant: 'error' });
      throw error;
    }
  };

  const addUserToGroup = async ({ userId, circleId }) => {
    try {
      const result = await addUserToGroupTrigger({ userId, circleId }).unwrap();
      enqueueSnackbar(i18next.t('users.addToGroup'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.addToGroupFailed'), { variant: 'error' });
      throw error;
    }
  };

  const removeUserFromGroup = async ({ userId, circleId }) => {
    try {
      const result = await removeUserFromGroupTrigger({ userId, circleId }).unwrap();
      enqueueSnackbar(i18next.t('users.removeFromGroup'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.removeFromGroupFailed'), { variant: 'error' });
      throw error;
    }
  };

  const addUserToCourse = async ({ userId, courseId, role }) => {
    try {
      const result = await addUserToCourseTrigger({ userId, courseId, role }).unwrap();
      enqueueSnackbar(i18next.t('users.addToCourse'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.addToCourseFailed'), { variant: 'error' });
      throw error;
    }
  };

  const removeUserFromStore = async ({ userId }) => {
    try {
      const result = await removeUserFromStoreTrigger({ userId }).unwrap();
      enqueueSnackbar(i18next.t('users.removeFromAllCourses'), { variant: 'success' });
      return result;
    } catch (error) {
      enqueueSnackbar(i18next.t('users.removeFromAllCoursesFailed'), { variant: 'error' });
      throw error;
    }
  };

  return {
    removeUserFromCourse,
    addUserToGroup,
    removeUserFromGroup,
    addUserToCourse,
    removeUserFromStore,
  };
};

